// Mini cart gender image fix
// Handles both Shopify native cart drawer AND Essential cart app
(function() {
  var observer;
  var swapping = false;

  function swapImg(img, src) {
    if (!img || !src) return;
    var clone = img.cloneNode(false);
    clone.removeAttribute('loading');
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.src = src;
    clone.setAttribute('srcset', src);
    if (img.parentNode) img.parentNode.replaceChild(clone, img);
  }

  // Get correct gender image URL for a product given its handle
  // by looking it up from already-rendered product cards on the page
  function getGenderImageFromPage(productHandle, gender) {
    var cards = document.querySelectorAll('product-card[data-img-' + gender + ']');
    for (var i = 0; i < cards.length; i++) {
      var link = cards[i].querySelector('a.product-card__link');
      if (link && link.href && link.href.includes(productHandle)) {
        return cards[i].getAttribute('data-img-' + gender);
      }
    }
    return null;
  }

  // Fix Shopify native cart drawer images
  function fixNativeCartImages(root) {
    var gender = sessionStorage.getItem('evdnce_gender');
    if (!gender) return;
    var scope = root || document;
    scope.querySelectorAll('[data-img-' + gender + ']').forEach(function(el) {
      var src = el.getAttribute('data-img-' + gender);
      var img = el.querySelector('img');
      if (img && src) swapImg(img, src);
    });
  }

  // Fix Essential cart app images
  // Essential uses data-essential-cart-element="line-item-image" on its img tags
  // The alt text contains [men]/[women] tags — we use that plus the product handle
  // to find the correct gender image from rendered product cards
  function fixEssentialCartImages() {
    var gender = sessionStorage.getItem('evdnce_gender');
    if (!gender) return;
    var opposite = gender === 'men' ? 'women' : 'men';

    document.querySelectorAll('[data-essential-cart-element="line-item-image"]').forEach(function(img) {
      var alt = (img.getAttribute('alt') || '').toLowerCase();

      // Only swap if currently showing opposite gender
      if (!alt.includes('[' + opposite + ']') && !alt.includes('[adam]')) return;

      // Get product handle from the parent link href
      var link = img.closest('a[href*="/products/"]');
      if (!link) return;
      var hrefMatch = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!hrefMatch) return;
      var handle = hrefMatch[1];

      // Find the correct gender image from product cards already on the page
      var newSrc = getGenderImageFromPage(handle, gender);
      if (newSrc) {
        swapImg(img, newSrc);
        return;
      }

      // Fallback: fetch the product JSON to get the correct image
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var images = product.images || [];
          // Find first image whose alt contains [gender] tag
          // Note: product.js doesn't return alt text directly
          // so use media array if available
          var media = product.media || [];
          for (var i = 0; i < media.length; i++) {
            var mediaAlt = (media[i].alt || '').toLowerCase();
            if (mediaAlt.includes('[' + gender + ']')) {
              var src = media[i].src || media[i].preview_image && media[i].preview_image.src;
              if (src) { swapImg(img, src); return; }
            }
          }
        })
        .catch(function() {});
    });
  }

  // Watch Shopify native CartDrawer-Body
  function watchNativeCartBody() {
    var cartBody = document.getElementById('CartDrawer-Body');
    if (!cartBody) {
      setTimeout(watchNativeCartBody, 300);
      return;
    }

    observer = new MutationObserver(function(mutations) {
      if (swapping) return;
      var hasChanges = mutations.some(function(m) {
        return m.addedNodes.length > 0 || m.removedNodes.length > 0;
      });
      if (!hasChanges) return;
      swapping = true;
      setTimeout(function() {
        fixNativeCartImages(cartBody);
        swapping = false;
      }, 50);
      setTimeout(function() {
        fixNativeCartImages(cartBody);
      }, 400);
    });

    observer.observe(cartBody, { childList: true, subtree: true });
    fixNativeCartImages(cartBody);
  }

  // Watch for Essential cart drawer opening
  // Essential injects a div with data-essential-cart-element attributes
  function watchEssentialCart() {
    var bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          // Check if Essential cart drawer was added
          if (
            node.querySelector &&
            node.querySelector('[data-essential-cart-element="line-item-image"]')
          ) {
            setTimeout(fixEssentialCartImages, 50);
            setTimeout(fixEssentialCartImages, 300);
          }
        });
      });

      // Also check for image updates within existing Essential cart
      var hasEssentialImages = mutations.some(function(m) {
        return m.target &&
          m.target.closest &&
          m.target.closest('[data-essential-cart-element]');
      });
      if (hasEssentialImages) {
        setTimeout(fixEssentialCartImages, 50);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // Also run immediately in case Essential cart is already in DOM
    fixEssentialCartImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      watchNativeCartBody();
      watchEssentialCart();
    });
  } else {
    watchNativeCartBody();
    watchEssentialCart();
  }
})();
